module.exports = __webpack_public_path__ + "img/drachenmakivogelperspektive.f2c0d4a2.jpg";